import { useCallback } from "react";
import { client } from "@apolloClient/client";

interface RenderProps {
  clearCache: () => void;
}

interface CacheUtilitiesProviderProps {
  children: React.ReactNode | ((props: RenderProps) => React.ReactNode);
}

export function CacheUtilitiesProvider({
  children,
}: CacheUtilitiesProviderProps) {
  const clearCache = useCallback(() => {
    client.clearStore();
  }, []);
  return typeof children === "function" ? children({ clearCache }) : children;
}
